import { FilterParams } from "core/models";
import { observable, action } from "mobx";

class InventoryFilter extends FilterParams {
    @observable accessor productId;
    @observable accessor facilityId;

    constructor() {
        super();

        this.productId = null;
        this.facilityId = null;
    }

    @action
    reset() {
        this.productId = null;
        this.facilityId = null;
        super.reset();
    }
}

// NOTE: To use a custom filter, pass the following line of code to the BaseListViewStore configuration 
// queryConfig: {
//     filter: new InventoryFilter(),
// }

export default InventoryFilter;